import { connect } from 'react-redux';
import { isEmpty } from 'lodash';
import {
    clearFilters,
    getCurrentUserIndustriesInitial,
    getMostCommonIndustriesInitial,
    getCurrentUserIndustries,
    getMostCommonIndustries,
} from '../../../store/actions';
import { shouldDisplayIndustryFilter } from '../../../utils/industries';
import Filters from './Filters';

const mapStateToProps = (state, props) => {
    const filtersCounters = state.filters_counters || {};
    const workSample = filtersCounters.work_sample;
    const business = filtersCounters.business;
    const containIndustriesFilter =
        !isEmpty(getMostCommonIndustriesInitial(state)) || !isEmpty(getCurrentUserIndustriesInitial(state));
    const displayIndustry = shouldDisplayIndustryFilter() && containIndustriesFilter;

    return {
        breakdown: state.breakdown,
        displayBreakdown: state.displayBreakdown,
        totalCount: state.total_count,
        selectedStars: state.selectedStars,
        workSampleChecked: state.workSampleChecked,
        workSampleFilterCount: workSample,
        displayIndustry,
        currentUserIndustries: getCurrentUserIndustries(state),
        commonIndustries: getMostCommonIndustries(state),
        businessFilterCount: business,
        businessChecked: state.businessChecked,
        enableSearchFilter: state.enableSearchFilter,
        ...props,
    };
};

const mapDispatchToProps = (dispatch) => ({
    clearFilters: () => dispatch(clearFilters()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Filters);
